import React, { useMemo } from "react";
import { Coffee } from "lucide-react";

const PreorderBanner = ({ launchDate }) => {
    const shipDate = useMemo(() => {
        try {
            return new Date(launchDate).toLocaleDateString(undefined, {
                month: "long",
                day: "numeric",
                year: "numeric",
            });
        } catch {
            return "July 1, 2026";
        }
    }, [launchDate]);

    return (
        <div
            data-testid="preorder-banner"
            className="w-full bg-[#004466] text-white"
        >
            <div className="max-w-[1400px] mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-center">
                <Coffee className="w-4 h-4 text-white/80 flex-shrink-0" />
                <p className="font-chivo text-[11px] sm:text-xs tracking-[0.18em] uppercase">
                    <span className="font-bold">Pre-Orders Open</span>
                    <span className="hidden sm:inline">
                        {" "}
                        — Roasted Fresh, Ships{" "}
                        <span className="text-white font-bold">{shipDate}</span>
                    </span>
                    <span className="sm:hidden"> · Ships {shipDate}</span>
                </p>
            </div>
        </div>
    );
};

export default PreorderBanner;
